import { Link, Stack, Typography } from "@material-ui/core";
import { Box } from "@material-ui/system";
import { ProviderItems } from "src/models/StakingPool";
import { ProviderItem } from "./ProviderItem";
import { DetailsTokenModal } from "src/modals/DetailsTokenModal";
import { useState } from "react";

export const Web3Info = (props: { datas: ProviderItems[], title: string, subTitle: string, moreUrl: string }) => {

  const [data, setData] = useState<ProviderItems>();
  const [visible, setVisible] = useState<boolean>(false);
  return (
    <Box p="50px 95px 74px">
      <Box mt="60px">
        <Typography
          fontSize="16px"
          color="white"
          borderBottom="solid 1px white"
          sx={{
            display: "inline",
          }}
        >
          Mainnet
        </Typography>
      </Box>



      <Box
        mt="60px"
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(5, 200px)",
          rowGap: "50px",
          justifyContent: "space-between",
        }}
      >
        {props.datas.map((item) => (
          <ProviderItem
            key={item.nodeName}
            providerItem={item}
            onClick={() => {
              if (item.showModal) {
                setData(item);
                setVisible(true);
              } else {
                if (item.type != "Soon") {
                  window.open(item.url)
                }
              }

            }}
          />
        ))}
      </Box>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        mt="200px"
      >
        <Typography
          fontSize="30px"
          variant="bold"
          color="white"
          lineHeight="30px"
        >
          More projects are coming soon
        </Typography>

        <Stack direction="row" mt="4px" mb="15px" alignItems="center">
          <Typography color="#909FB5" fontSize="20px" ml="8px">
            Projects builder can invite Wetez to join as a API Provider
          </Typography>

          <Link
            target="_blank"
            href="https://forms.gle/zxgjAEkL59uMc29b6"
            ml="4px"
            sx={{
              color: "#00A5F6",
              textDecorationColor: "#00A5F6",
            }}
          >
            <Typography variant="bold" fontSize="20px" color="primary">
              here
            </Typography>
          </Link>

          <Typography color="#909FB5" fontSize="20px">
            .
          </Typography>
        </Stack>
      </Box>
      {data && <DetailsTokenModal item={data} visible={visible} handleClose={() => {
        setVisible(false);
      }} />}
    </Box>
  );
};
